// ✅ Importaciones
import {
  CardNumberElement, // Campo de número de tarjeta de Stripe
  CardExpiryElement, // Campo de fecha de expiración de Stripe
  CardCvcElement,    // Campo de CVC de Stripe
} from '@stripe/react-stripe-js';

// 🔹 Definición de las props que recibirá el componente
interface CardInputProps {
  name: string;                    // Nombre del titular de la tarjeta
  setName: (value: string) => void; // Función para actualizar el nombre
  focus: string;                    // Campo actualmente enfocado (no usado directamente aquí)
  setFocus: (value: any) => void;   // Función para actualizar el campo enfocado
}

// 💳 Componente funcional que renderiza los inputs de tarjeta
const CardInput: React.FC<CardInputProps> = ({
  name,
  setName,
  setFocus,
}) => (
  <div className="space-y-4">
    
    {/* Campo para el nombre del titular */}
    <input
      type="text"
      name="name"
      placeholder="Nombre del titular"
      value={name}
      onChange={(e) => setName(e.target.value)}  // Actualiza el estado del nombre
      onFocus={() => setFocus('name')}          // Actualiza el estado de foco cuando se enfoca
      className="border p-1 pl-2 w-full rounded-lg bg-white"
    />

    {/* Campo de número de tarjeta de Stripe */}
    <div onFocus={() => setFocus('number')}>
      <CardNumberElement className="border p-1.5 rounded-lg bg-white" />
    </div>

    {/* Campos de fecha de expiración y CVC */}
    <div className="w-full grid grid-cols-2 space-x-2">
      
      {/* Expiración de la tarjeta */}
      <div onFocus={() => setFocus('expiry')} className="border p-1.5 rounded-lg bg-white">
        <CardExpiryElement />
      </div>

      {/* Código CVC */}
      <div onFocus={() => setFocus('cvc')} className="border p-1.5 rounded-lg bg-white">
        <CardCvcElement />
      </div>

    </div>
  </div>
);

// 🚀 Exportación del componente
export default CardInput;
